import React from 'react';
import PropTypes from 'prop-types';
import { EMAIL_TEMPLATE_TYPE } from '../../../../utility/AlertNotificationTemplateUtils';

function NotificationTemplate(props) {
  const {
    subjectFieldId,
    bodyFieldId,
    onSubjectTextChange,
    onBodyTextChange,
    onSubjectCursorPropertiesUpdate,
    onBodyCursorPropertiesUpdate,
    subjectTemplateText,
    bodyTemplateText,
    templateType,
  } = props;

  const createOnSubjectTextChangeHandler = (e) => {
    onSubjectTextChange(e);
  };

  const createOnBodyTextChangeHandler = (e) => {
    onBodyTextChange(e);
  };

  const createSubjectCursorPropertiesUpdate = (e) => {
    onSubjectCursorPropertiesUpdate(e);
  };

  const createBodyCursorPropertiesUpdate = (e) => {
    onBodyCursorPropertiesUpdate(e);
  };

  return (
    <>
      { templateType === EMAIL_TEMPLATE_TYPE && (
        <>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label>Subject</label>
          <input
            name={subjectFieldId}
            className="form-control"
            aria-label="subject template"
            value={subjectTemplateText}
            onChange={createOnSubjectTextChangeHandler}
            onClick={createSubjectCursorPropertiesUpdate}
          />
        </>
      )}
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label>Body</label>
      <textarea
        name={bodyFieldId}
        className="form-control"
        aria-label="body template"
        rows={7}
        value={bodyTemplateText}
        onChange={createOnBodyTextChangeHandler}
        onClick={createBodyCursorPropertiesUpdate}
        onKeyUp={createBodyCursorPropertiesUpdate}
      />
    </>
  );
}

NotificationTemplate.defaultProps = {
  subjectTemplateText: null,
  onSubjectTextChange: null,
  onSubjectCursorPropertiesUpdate: null,
  subjectFieldId: null,
};

NotificationTemplate.propTypes = {
  templateType: PropTypes.string.isRequired,
  bodyTemplateText: PropTypes.string.isRequired,
  onBodyTextChange: PropTypes.func.isRequired,
  onBodyCursorPropertiesUpdate: PropTypes.func.isRequired,
  bodyFieldId: PropTypes.string.isRequired,
  subjectTemplateText: PropTypes.string,
  onSubjectTextChange: PropTypes.func,
  onSubjectCursorPropertiesUpdate: PropTypes.func,
  subjectFieldId: PropTypes.string,
};

export default NotificationTemplate;
